export default __webpack_public_path__ + "static/media/back-pain.ba09b49b.jpg";